import React from "react";

export default function EtsyIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={16} height={16} x={0.5} fill="#F56400" rx={8} />
      <path
        fill="#fff"
        d="M7.4 4.746v2.96s.987 0 1.515-.042c.416-.076.492-.119.569-.558l.153-.643h.451l-.076 1.405.04 1.44h-.455l-.113-.562c-.113-.4-.266-.481-.569-.52-.378-.042-1.515-.042-1.515-.042v2.483c0 .478.23.681.758.681H9.75c.492 0 .983-.042 1.29-.8l.411-.963h.382c-.04.2-.229 1.964-.265 2.36 0 0-1.44-.038-2.044-.038H6.795l-1.628.038v-.435l.528-.123c.382-.08.495-.2.495-.52 0 0 .04-1.082.04-2.884 0-1.797-.04-2.88-.04-2.88 0-.358-.113-.439-.495-.52l-.528-.118v-.439l1.592.035h3.03c.605 0 1.625-.116 1.625-.116s-.036.678-.076 2.28h-.416l-.153-.563c-.149-.72-.375-1.078-.794-1.078H7.593c-.193 0-.193.039-.193.162Z"
      />
    </svg>
  );
}
